import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lf-angular-todo',
  templateUrl: './angular-todo.component.html',
  styleUrls: ['./angular-todo.component.css']

})
export class AngularTodoComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
